import { useContext } from 'react';
import { dataStore } from 'store/data';
import { appStore } from 'store/app';

const useGetIncompatibleParts = (id) => {
  const [{ incompatible }] = useContext(dataStore);
  const [{ customData }] = useContext(appStore);
  let isIncompatible = false;

  if (!incompatible) {
    return isIncompatible;
  }

  const exclusionList = [];

  // 非互換リストから ID が含まれたオブジェクトのキー名を除外リストに追加していく
  for (const [key, list] of Object.entries(incompatible.list)) {
    const exclusions = list.filter((listId) => listId === id);
    if (exclusions.length) {
      exclusionList.push(key);
    }
  }

  // 選択済みのボトルカラーの ID が除外リストにあれば、非互換フラグを返す
  if (exclusionList.length) {
    exclusionList.forEach((exclusionId) => {
      switch (incompatible.source) {
        case 'Bottle':
          if (customData.bottleColorData.product_id === exclusionId) {
            isIncompatible = true;
          }
          break;
        case 'BottleSize':
          if (customData.bottle.size === exclusionId) {
            isIncompatible = true;
          }
          break;
        default:
          break;
      }
    });
  }
  return isIncompatible;
};

export default useGetIncompatibleParts;
